import React,{Component} from 'react';
import './lottery.css'
import Footer from '../../Home/Home_modules/Footerr/footer'
import ProgressBar from "@ramonak/react-progress-bar";
import Progressbar from '../../Components/progressbar'
import firebaseConfig from '../../fire';
import firebase from 'firebase/compat/app';
import ShareButton from "react-web-share-button";
import Dropdown from '../../Components/Dropdown';
import StripeCheckoutButton from '../../Components/stripe.button.component';
import transakSDK from "@transak/transak-sdk";
import CoinbaseCommerceButton from 'react-coinbase-commerce';
import 'react-coinbase-commerce/dist/coinbase-commerce-button.css';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const divStyle = {
    borderColor: '#ffffff',
    backgroundColor:'#ffffff',
   
  };

const settings = {
    apiKey: '7ee97202-2ff8-4a9c-a50a-84fd08df0fef',  // Your API Key
    environment: 'STAGING', // STAGING/PRODUCTION
    defaultCryptoCurrency: 'ETH',
    themeColor: '020002', // App theme color
    hostURL: window.location.origin,
    widgetHeight: "500px",
    widgetWidth: "500px",
}


export function openTransak() {
    const transak = new transakSDK(settings);
    transak.init();
}

class React_inner extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            lotteryData: [],
            totalPrice: '',
        }
        this.handlePopup = this.handlePopup.bind(this);
        this.popupClose = this.popupClose.bind(this);
        this.count = 1;
        this.incrementCount = this.incrementCount.bind(this);
        this.decrementCount = this.decrementCount.bind(this);
        this.handlePrice = this.handlePrice.bind(this);
        this.triggerBuy = this.triggerBuy.bind(this);
    }
    
    handlePopup(){
        document.querySelector(".lottery-pop-container").classList.add("popup-active");
    }
    popupClose(){
        document.querySelector(".lottery-pop-container").classList.remove("popup-active");
    }
    incrementCount(){
        this.count++;
        document.getElementById("ticket-count").value = this.count;
        this.handlePrice();
    }
    decrementCount(){
        if(this.count > 1){
            this.count--;
            document.getElementById("ticket-count").value = this.count;
        }
        this.handlePrice();
    }
    handlePrice(){
        var price = document.getElementById("ticket-count").value;
        var initialPrice = this.state.lotteryData.ticket_price;
        var totalPrice = price * initialPrice;
        document.getElementById("lottery-price").innerHTML = "$" + totalPrice;
        this.setState({totalPrice: totalPrice});
       // const totalTickets = document.getElementById('ticket-count').value;
       // console.log(totalTickets);
    }
    triggerBuy(){
        const currentUrl = window.location.pathname;
        localStorage.setItem('currentUrl', currentUrl);
        firebaseConfig.auth().onAuthStateChanged(function(user) {
            if(user) {
                //Here you can place the code that you want to run if the user is logged in
            } else {
                window.location.href = "../login";
            }    
        }
        )
    }
    Opentransak = () =>{
        const totalTickets = document.getElementById('ticket-count').value;
        console.log(totalTickets);
        document.querySelector(".lottery-pop-container").classList.remove("popup-active");
        const transak = new transakSDK(settings);
        transak.init();
    }
    coin = () =>{
        const totalTickets = document.getElementById('ticket-count').value;
        localStorage.setItem('totalTickets', totalTickets);
        if (localStorage.getItem("LAST_ACTIVE_ACCOUNT") === null) {
            //alert("No Value")
            alert("Please Connect Wallet to Proceed");
            window.location.href ="../../../Wallet/";
        }
        else{
            toast.success("Processing Payment");
            const lottery_id = localStorage.getItem('lottery_id') //getting the particular value from the local storage
            fetch('https://api.commerce.coinbase.com/charges/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CC-Api-Key': 'cdb03156-5c75-4642-9b2a-4f8ee221a276',
                    'X-CC-Version': '2018-03-22'
                },
                body: JSON.stringify({
                    "name": "Diginoor",
                    "description": "India's First Cine NFT Marketplace",
                    "local_price": {
                    "amount": ""+this.state.totalPrice,
                    "currency": "USD"
                },
                "pricing_type": "fixed_price",
                "redirect_url": "http://localhost:3000/lottery_purchased/"+lottery_id,
                "cancel_url": "http://localhost:3000/lottery/"+lottery_id,
            }
            )
        }
        )
        .then(response => response.json())
        .then(data => {
          console.log(data)
          localStorage.setItem('coinbase_url', data.data.hosted_url)
          console.log(data.data.hosted_url)
          window.location.href = data.data.hosted_url
        })
      }
      }



    componentWillMount(){
        const lotteryId = this.props.match.params.id;
       // console.log(lotteryId);
        const lotteryRef = firebase
        .firestore()
        .collection("lottery") // Collection Name
        .doc(lotteryId); // Docment id
         lotteryRef.get().then((doc) => {
         if (!doc.exists) return;
        // console.log("Individual Lottery data:", doc.data());
          this.setState({lotteryData: doc.data()});
          this.setState({totalPrice: this.state.lotteryData.ticket_price});
          const id = ""+ lotteryId;
          localStorage.setItem('lottery_id', id);
          localStorage.setItem('NFT Price', this.state.totalPrice);
        });
    }

    render(){
        return(
            <>
            <div className="container-fluid lottery-inner-main">
                
                <div className="featured-btns">
                    <button class="vdo-btnn">  <span className="glyphicon glyphicon-heart-empty"></span> Like</button>
                    <button class="vdo-btnn">   <span className="glyphicon glyphicon-share"></span> 
                    <ShareButton buttonStyle={divStyle}/>
                    </button>
                </div>
            </div>
            <div className="lottery-inner-section-2">
            <h2>TICKET HISTORY</h2>
                <div className="lottery-inner-section-2-grid">
                <div>
                <div className="lottery-winner-card">
                      <div>
                        <img />
                      </div>
                      <div>
                        <h4>Wallet Address</h4>
                        <p>September 28th, 2021</p>
                      </div>
                      <div>
                        <h4>Prize</h4>
                        <p>Sivaji</p>
                      </div>
                      </div>
                </div>
                <div>
                    <div className="lottery-details">
                        <div>
                            <h4>No. of players</h4>
                            <h2>{this.state.lotteryData.total_players}</h2>
                        </div>
                        <div>
                            <h4>Ticket price</h4>
                            <h2>${this.state.lotteryData.ticket_price}</h2>
                        </div>
                    </div>
                    <div className="ticket-details">
                        <div className="ticket-progress">
                            <h3>Minimum number of tickets to activate the lottery is 100</h3>
                            <div className='purchase-bar'>
                           <h2>{this.state.lotteryData.total_tickets}</h2>
                           <Progressbar bgcolor="#DF0974" borderColor='#DF0974' progress={this.state.lotteryData.total_tickets}  height={49} />
                   <h2>100</h2>
                   </div>
                        </div>
                        <div className="ticket-purchase-section">
                            <button className="ticket-purchase" onClick={this.handlePopup}>PURCHASE TICKETS</button>
                        </div>
                    </div>
                </div>
                </div>
            </div>

            {/* Payment Popup */}


            <div className="lottery-pop-container">
                <div className='lottery-pop-card'>
                    <div className="lottery-pop-close"><span  onClick={this.popupClose}>X</span></div>
                    <h3>Number of Tickets?</h3>
                    <p>You're about to buy lottery tickets for {this.state.lotteryData.lottery_name} The {this.state.lotteryData.lottery_name} by AVM Productions</p>
                    <img src={this.state.lotteryData.lottery_image}/>
                    <div className="ticket-count">
                        <div className='incbtn'>
                            <button onClick={this.incrementCount}>+</button>
                            <input onKeyUp={this.handlePrice} type='text' style={{color: 'white'}} id="ticket-count" value={this.count} />
                            <button onClick={this.decrementCount}>-</button>
                        </div>
                        <div>
                            <h6 id="lottery-price">${this.state.lotteryData.ticket_price}</h6>
                            </div>
                    </div>
                   {/* <button className='ticket-buy-btn'>Buy</button> */}
                    <div onClick={this.triggerBuy}>
                        <center> 
                    <Dropdown  label="Buy Crypto / Card">
                     <div class="row"> 
                     <div class="col-md-12"> 
                     <button className="place-a-bid-btn0" onClick={this.Opentransak}>Transak</button>
                     </div> </div> <br/>
                     <div class="row">
                     <div class="col-md-12"> 
                     <StripeCheckoutButton price={this.state.totalPrice} />
                     </div>
                     </div> <br/>
                     <div class="row">
                     <div class="col-md-12"> 
                     <button className="place-a-bid-btn0" onClick={this.coin}>Coinbase</button>
                     </div>   
                     </div>
                        </Dropdown>
                        </center>
                        </div>
                </div>
            </div>

            {/* Footer */}


            <Footer/>
            </>
        )
    }
}
export default React_inner